import { r as n, h as t, H as r } from "./main-bb89b2f2.js";
import "vue";
const l = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.block{display:block}:host{display:block}.static{position:static}.accent-ruby{accent-color:var(--color-accent-ruby)}", a = l, s = class {
  constructor(e) {
    n(this, e), this.backgroundColor = void 0, this.theme = void 0, this.mode = void 0, this._rerender = 0;
  }
  watchBackground() {
    this._rerender = (/* @__PURE__ */ new Date()).getTime();
  }
  watchTheme() {
    this._rerender = (/* @__PURE__ */ new Date()).getTime();
  }
  watchMode() {
    this._rerender = (/* @__PURE__ */ new Date()).getTime();
  }
  render() {
    let e = null;
    this.backgroundColor != null && (this.backgroundColor.startsWith("steel-") ? e = `var(--color-neutral-${this.backgroundColor})` : e = `var(--color-${this.backgroundColor})`);
    const o = {
      "patternlib-root": !0
    }, i = {
      "background-color": e
    };
    return this.theme == null && e == null ? t(r, null, t("slot", null)) : t(r, { class: o, style: i, theme: this.theme, "data-mode": this.mode }, t("slot", null));
  }
  static get watchers() {
    return {
      backgroundColor: ["watchBackground"],
      theme: ["watchTheme"],
      mode: ["watchMode"]
    };
  }
};
s.style = a;
export {
  s as patternlib_theme
};
